import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start at 14 minutes 39 seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 39);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="bg-green-600 text-white py-1 px-4 text-center font-semibold text-xs md:text-sm sticky top-0 z-50 shadow-sm" data-id="element-36">
      <div className="flex items-center justify-center gap-1.5" data-id="element-37">
        <Clock className="w-3 h-3 animate-pulse" data-id="element-38" />
        <span data-id="element-39">Oferta termina en: {formatTime(timeLeft)}</span>
      </div>
    </div>;
}